import {
    SET_ACCOUNT_CODE_LOADING,
    SET_ACCOUNT_CODE_DATA,
    SET_ALL_CONTRACTS_LOADING,
    SET_SELECTED_CONTRACT_PERIODS_LOADING,
    SET_CLIN_MATRIX_LOADING,
    SET_CLIN_MATRIX,
    SET_CONTRACTS,
    SET_PERIODS,
    SET_SELECTED_CONTRACT_ID,
    SET_SELECTED_PERIOD_ID,
    SET_CLIN_ASSOCIATIONS
} from '../types';

const initialState = {
    loading: false,
    loadingContracts: false,
    loadingPeriods: false,
    loadingClins: false,
    accountCodeData: { account_code: {} },
    clin_matrix: [],
    clin_associations: [],
    selected_contract_id: null,
    selected_period_id: null,
    contracts: [],
    periods: []
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ACCOUNT_CODE_LOADING:
            return {
                ...state,
                loading: payload
            };
        case SET_ALL_CONTRACTS_LOADING:
            return {
                ...state,
                loadingContracts: payload
            };
        case SET_SELECTED_CONTRACT_PERIODS_LOADING:
            return {
                ...state,
                loadingPeriods: payload
            };
        case SET_CLIN_MATRIX_LOADING:
            return {
                ...state,
                loadingClins: payload
            };
        case SET_ACCOUNT_CODE_DATA:
            return {
                ...state,
                accountCodeData: { ...payload }
            };
        case SET_CLIN_MATRIX:
            return {
                ...state,
                clin_matrix: payload
            };
        case SET_CLIN_ASSOCIATIONS:
            return {
                ...state,
                clin_associations: payload
            };
        case SET_SELECTED_CONTRACT_ID:
            return {
                ...state,
                selected_contract_id: payload
            };
        case SET_SELECTED_PERIOD_ID:
            return {
                ...state,
                selected_period_id: payload
            };
        case SET_CONTRACTS:
            return {
                ...state,
                contracts: payload
            };
        case SET_PERIODS:
            return {
                ...state,
                periods: payload
            };
        default:
            return state;
    }
}